export type ScheduledJobFrequencyType = 'CRON' | 'PERIODIC' | 'ONE_SHOT';

export interface ScheduledJobConfigResponse {
  id: number;
  jobKey: string;
  description: string | null;
  enabled: boolean;
  frequencyType: ScheduledJobFrequencyType;
  cronExpression: string | null;
  intervalSeconds: number | null;
  executeAt: string | null;
  timezone: string;
  params: Record<string, unknown> | null;
  maxRetries: number;
  retryBackoffSeconds: number;
  createdAt: string;
  updatedAt: string;
}

export interface ScheduledJobExecutionResponse {
  id: number;
  jobConfigId: number;
  startTime: string;
  endTime: string | null;
  status: 'RUNNING' | 'SUCCESS' | 'FAILED';
  message: string | null;
  durationMs: number | null;
  retryCount: number;
  triggeredManually: boolean;
  createdAt: string;
}

export interface ScheduledJobConfigRequest {
  jobKey: string;
  description?: string;
  enabled?: boolean;
  frequencyType: ScheduledJobFrequencyType;
  cronExpression?: string;
  intervalSeconds?: number;
  executeAt?: string;
  timezone?: string;
  params?: Record<string, unknown>;
  maxRetries?: number;
  retryBackoffSeconds?: number;
}

export interface ScheduledJobEnabledRequest {
  enabled: boolean;
}

/**
 * Etiquetas en español de los estados de ejecución de un job programado.
 * Vive junto al tipo porque el enum es de la infraestructura compartida
 * (lo consumen Segmentos, Monedas y cualquier módulo que agende trabajos).
 */
export const SCHEDULED_JOB_EXECUTION_STATUS_LABELS: Readonly<Record<string, string>> = {
  RUNNING: 'En ejecución',
  SUCCESS: 'Exitoso',
  FAILED: 'Fallido',
};

export function scheduledJobExecutionStatusLabel(status: string | null | undefined): string {
  if (!status) return '—';
  return SCHEDULED_JOB_EXECUTION_STATUS_LABELS[status] ?? status;
}

export const SCHEDULED_JOB_FREQUENCY_LABELS: Readonly<Record<string, string>> = {
  CRON: 'Expresión cron',
  PERIODIC: 'Cada cierto intervalo',
  ONE_SHOT: 'Una sola vez',
};
